<footer class="fixed-bottom pimeo-blue disable-selection">
    <div class="footer-content">
        <p class="left-content">
            Mobile Cloud Systems &copy; {{ year }}. All Rights Reserved.
        </p>
        <p class="right-content">
            <a class="text-white" [routerLink]="['/privacy-policy']">Privacy Policy</a>
        </p>
    </div>
</footer>
